import { AnyAction } from 'redux';
import { userInputActions, UserInputState } from './userInput.types';

export const userInputInitialState: UserInputState = {};

export const userInputReducer: (state: UserInputState | undefined, action: AnyAction) => UserInputState = (
	state = userInputInitialState,
	action
): UserInputState => {
	if (action.type === userInputActions.saveUserInput) {
		return {
			...state,
			...action.payload,
		};
	}
	if (action.type === userInputActions.clearUserInput) {
		return {
			...userInputInitialState,
			email: state.email,
			hasIntegratedSolution: state.hasIntegratedSolution,
		};
	}
	return state;
};
